import EmptyItem from './empty-item';

export default EmptyItem;
